export const PUBLISHER_IMPORT_LOADING_MESSAGES = [
  { icon: '📤', text: 'Prendiamo in consegna il tuo file...' },
  { icon: '🔍', text: 'Analizziamo il contenuto del documento...' },
  { icon: '🎨', text: 'Riconosciamo testi, colori e immagini...' },
  { icon: '📐', text: 'Ricostruiamo il layout su Giotto...' },
  { icon: '🪄', text: 'Adattiamo formati e dimensioni...' },
  { icon: '✨', text: "Ottimizziamo l'impaginazione..." },
  { icon: '💎', text: 'Ultimi ritocchi al tuo modello...' },
  { icon: '⏳', text: 'Manca poco, ancora un istante...' },
];

const BYTES_PER_MIB = 1024 * 1024;
const MIN_PROGRESS_DURATION_MS = 60000;
const BASE_PROGRESS_DURATION_MS = 45000;
const PROGRESS_MS_PER_MIB = 5750;
const MAX_PROGRESS_DURATION_MS = 10 * 60 * 1000;
const PROGRESS_TARGET_PERCENT = 92;
const MAX_MESSAGE_CYCLE_DURATION_MS = 2 * 60 * 1000;

const clamp = (value, min, max) => Math.max(min, Math.min(value, max));

/**
 * Estimate the simulated conversion progress duration from the source file
 * size. Calibrated on prod Publisher imports: an 82.8 MiB file completed the
 * worker in ~521.6s after image optimization was deployed.
 */
export const getPublisherImportProgressTiming = (fileSizeBytes = 0) => {
  const safeFileSizeBytes =
    Number.isFinite(fileSizeBytes) && fileSizeBytes > 0 ? fileSizeBytes : 0;
  const fileSizeMiB = safeFileSizeBytes / BYTES_PER_MIB;
  const rawDurationMs =
    BASE_PROGRESS_DURATION_MS + fileSizeMiB * PROGRESS_MS_PER_MIB;
  const durationMs =
    Math.round(
      clamp(rawDurationMs, MIN_PROGRESS_DURATION_MS, MAX_PROGRESS_DURATION_MS) /
        1000
    ) * 1000;

  return {
    durationMs,
    messageCycleDurationMs: Math.min(durationMs, MAX_MESSAGE_CYCLE_DURATION_MS),
    progressTargetPercent: PROGRESS_TARGET_PERCENT,
  };
};
